module.exports = require('./PawnbrokerAnnualReportView');
